module.exports = require('./PawnbrokerAnnualReportView');
